import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/fanhui.png';
import _imports_1 from '../assets/image/sign_bg@2x.9ac900b.png';
const _withScopeId = n => (_pushScopeId("data-v-2b781e39"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "headers"
};
const _hoisted_4 = {
  class: "icon"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fanhui",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px",
    "color": "#fff"
  }
}, null, -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "46px"
  }
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logins"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_10 = {
  class: "signIn"
};
const _hoisted_11 = {
  class: "lable"
};
const _hoisted_12 = {
  class: "lable"
};
const _hoisted_13 = {
  class: "lable"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lable"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "submit",
  type: "submit"
}, "登陆")], -1));
const _hoisted_16 = {
  class: "lable"
};
import nav_header from '../components/nav_header.vue';
import msgs from '../components/prompt.vue';
import { login, codeImg } from '../util/http';

import { useRouter } from 'vue-router';
import { ref, reactive, onBeforeMount } from 'vue';
export default {
  __name: 'login',
  setup(__props) {
    const router = useRouter();
    let codeImage = ref('');
    let msg = ref('账号不能为空');
    let show = ref(false);
    let query = reactive({
      mobile: '',
      password: '',
      key: ''
    });
    onBeforeMount(() => {
      repeatImg();
    });
    let returnUp = () => {
      router.push({
        path: `/`
      });
    };
    let timeout;
    let msgss = () => {
      show.value = true;
      if (show.value) {
        timeout = setTimeout(() => {
          show.value = false;
        }, 1000);
      } else {
        clearTimeout(timeout);
      }
    };
    let onSubmit = e => {
      e.preventDefault();
      if (query.mobile == '' || query.password == '') {
        msgss();
        msg.value = '账号密码不能为空';
        repeatImg();
      } else {
        show.value = false;
        logins(query);
      }
    };
    let logins = data => {
      login(data).then(res => {
        if (res.message == "成功") {
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem('chat', JSON.stringify(res.data.chat));
          localStorage.setItem(res.data.token_type, res.data.token);
          router.push({
            path: `/`
          });
        } else {
          msgss();
          msg.value = res.message;
          repeatImg();
        }
      });
    };
    let repeatImg = () => {
      codeImg().then(res => {
        codeImage.value = res.data.image;
        query.key = res.data.key;
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "left",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(returnUp) && _unref(returnUp)(...args))
      }, _hoisted_7)])]), _hoisted_8, _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("form", {
        action: "",
        onSubmit: _cache[5] || (_cache[5] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args))
      }, [_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(query).mobile = $event),
        placeholder: "请输入账号"
      }, null, 512), [[_vModelText, _unref(query).mobile]])]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(query).password = $event),
        placeholder: "请输入密码"
      }, null, 512), [[_vModelText, _unref(query).password]])]), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
        class: "code",
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(query).code = $event),
        placeholder: "请输入验证码"
      }, null, 512), [[_vModelText, _unref(query).code]]), _createElementVNode("div", {
        class: "img",
        onClick: _cache[4] || (_cache[4] = (...args) => _unref(repeatImg) && _unref(repeatImg)(...args))
      }, [_createElementVNode("img", {
        src: _unref(codeImage),
        alt: ""
      }, null, 8, _hoisted_14)])]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_router_link, {
        to: ""
      }, {
        default: _withCtx(() => [_createTextVNode(" 忘记密码 ")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/register"
      }, {
        default: _withCtx(() => [_createTextVNode(" 立即注册 ")]),
        _: 1
      })])], 32)])]), _createVNode(msgs, {
        msg: _unref(msg),
        hidden: _unref(show)
      }, null, 8, ["msg", "hidden"])], 64);
    };
  }
};